module.exports = {
	"version": "1.2207.8",
	"manifest": {
		"adminLoginButton": "1.2200.2",
		"animations": "1.2186.4",
		"audioCommon": "1.2160.7",
		"audioPlayer": "1.2080.9",
		"backToTopButton": "1.2177.3",
		"backgroundCommon": "1.2200.2",
		"balata": "1.2207.8",
		"bgImageStrip": "1.2108.3",
		"boxSlideShowSlide": "1.2144.4",
		"buttonCommon": "1.2080.9",
		"checkbox": "1.2200.2",
		"clipArt": "1.2200.2",
		"column": "1.2108.3",
		"comboBoxInput": "1.2108.3",
		"compDesignUtils": "1.2080.9",
		"compUtils": "1.2186.4",
		"components": "1.2207.8",
		"componentsPreviewLayer": "1.2186.5",
		"contactForm": "1.2080.9",
		"container": "1.2010.8",
		"containerCommon": "1.2010.8",
		"core": "1.2207.8",
		"coreUtils": "1.2207.8",
		"dataFixer": "1.2207.8",
		"datePicker": "1.2186.4",
		"dateUtils": "1.2010.8",
		"deadComponent": "1.2040.17",
		"displayer": "1.2177.3",
		"documentMedia": "1.2080.9",
		"documentServices": "1.2207.8",
		"dropDownMenu": "1.2186.4",
		"editingRendererPlugins": "1.2010.8",
		"exitMobileModeButton": "1.2080.9",
		"facebookComments": "1.2160.7",
		"facebookLike": "1.2186.4",
		"facebookLikeBox": "1.2010.8",
		"facebookShare": "1.2108.3",
		"fileUploader": "1.2160.7",
		"flashComponent": "1.2108.3",
		"flickrBadgeWidget": "1.2186.4",
		"fonts": "1.2177.3",
		"fontsPrefetch": "1.2010.8",
		"footerContainer": "1.2010.8",
		"formCommon": "1.2144.4",
		"galleriesCommon": "1.2108.3",
		"googleMap": "1.2080.9",
		"groupContainer": "1.2040.17",
		"headerContainer": "1.2010.8",
		"hoverBox": "1.2108.3",
		"htmlComponent": "1.2177.3",
		"image": "1.2186.4",
		"imageButton": "1.2040.17",
		"imageClientApi": "1.2177.3",
		"imageCommon": "1.2108.3",
		"imageZoom": "1.2177.3",
		"imageZoomDisplayer": "1.2177.3",
		"infoTip": "1.2200.2",
		"itunesButton": "1.2108.3",
		"layout": "1.2207.8",
		"linkBar": "1.2080.9",
		"loggingUtils": "1.2200.2",
		"loginButton": "1.2108.3",
		"matrixGallery": "1.2177.3",
		"mediaCommon": "1.2207.8",
		"mediaContainerFactory": "1.2144.4",
		"mediaControls": "1.2207.8",
		"mediaPlayer": "1.2200.2",
		"mediaZoom": "1.2177.3",
		"menuButton": "1.2186.4",
		"messageView": "1.2149.2",
		"mobileActionsMenu": "1.2177.3",
		"multilingual": "1.2207.8",
		"page": "1.2144.4",
		"paginatedGridGallery": "1.2186.4",
		"paypalButton": "1.2010.8",
		"pinItPinWidget": "1.2144.4",
		"pinterestFollow": "1.2080.9",
		"pinterestPinIt": "1.2186.4",
		"popupCloseTextButton": "1.2108.3",
		"popupContainer": "1.2144.4",
		"previewExtensionsCore": "1.2144.4",
		"qaAutomation": "1.2080.9",
		"quickActionBar": "1.2186.4",
		"radioButton": "1.2207.8",
		"radioGroup": "1.2207.8",
		"render": "1.2207.8",
		"rssButton": "1.2010.8",
		"santaPreview": "1.2186.4",
		"santaProps": "1.2207.8",
		"screenWidthContainer": "1.2010.8",
		"server": "1.2177.3",
		"singleAudioPlayer": "1.2080.9",
		"siteBackground": "1.2186.4",
		"siteButton": "1.2080.9",
		"siteUtils": "1.2207.8",
		"skinExports": "1.2200.2",
		"skins": "1.2207.8",
		"skypeCallButton": "1.2108.3",
		"slideShowGallery": "1.2200.2",
		"sliderGallery": "1.2200.2",
		"socialCommon": "1.2177.3",
		"soundCloudWidget": "1.2177.3",
		"spotifyFollow": "1.2186.4",
		"spotifyPlayer": "1.2177.3",
		"stripColumnsContainer": "1.2144.4",
		"stripContainer": "1.2144.4",
		"stripSlideShow": "1.2207.8",
		"stripSlideShowSlide": "1.2144.4",
		"subscribeForm": "1.2080.9",
		"svgCommon": "1.2207.8",
		"svgShape": "1.2207.8",
		"testUtils": "1.2207.8",
		"textArea": "1.2177.3",
		"textCommon": "1.2200.2",
		"textInput": "1.2010.8",
		"tinyMenu": "1.2207.8",
		"tpa": "1.2207.8",
		"tpaGalleries": "1.2207.8",
		"translationsUtils": "1.2128.6",
		"tweenEngine": "1.2160.7",
		"twitterFeed": "1.2010.8",
		"utils": "1.2200.2",
		"vKShareButton": "1.2186.4",
		"verticalAnchorsMenu": "1.2200.2",
		"verticalMenu": "1.2177.3",
		"video": "1.2160.7",
		"wGooglePlusOne": "1.2177.3",
		"wPhoto": "1.2160.7",
		"wRichText": "1.2080.9",
		"wTwitterFollow": "1.2010.8",
		"wTwitterTweet": "1.2177.3",
		"warmup": "1.2200.2",
		"widgets": "1.2207.8",
		"wixCode": "1.2207.8",
		"wixCodeInit": "1.2177.3",
		"wixCodeSeo": "1.2200.2",
		"wixSites": "1.2200.2",
		"wixSkinOnly": "1.2010.8",
		"wixUrlParser": "1.2144.4",
		"wixads": "1.2177.3",
		"wixappsBuilder": "1.2177.3",
		"wixappsClassics": "1.2207.8",
		"wixappsCore": "1.2200.2",
		"youTubeSubscribeButton": "1.2186.4",
		"zoomedImage": "1.2010.8"
	},
	"versions": {
		"mobx": "3.1.0",
		"mobxReact": "3.5.8",
		"lodash": "4.17.4/dist",
		"react": "0.14.3",
		"tweenmax": "1.19.0",
		"pmrpc": "1.30.0"
	},
	"packages": [
		"adminLoginButton",
		"animations",
		"audioCommon",
		"audioPlayer",
		"backToTopButton",
		"backgroundCommon",
		"balata",
		"bgImageStrip",
		"boxSlideShowSlide",
		"buttonCommon",
		"checkbox",
		"clipArt",
		"column",
		"comboBoxInput",
		"compDesignUtils",
		"compUtils",
		"components",
		"componentsPreviewLayer",
		"contactForm",
		"container",
		"containerCommon",
		"core",
		"coreUtils",
		"dataFixer",
		"datePicker",
		"dateUtils",
		"deadComponent",
		"displayer",
		"documentMedia",
		"documentServices",
		"dropDownMenu",
		"editingRendererPlugins",
		"exitMobileModeButton",
		"facebookComments",
		"facebookLike",
		"facebookLikeBox",
		"facebookShare",
		"fileUploader",
		"flashComponent",
		"flickrBadgeWidget",
		"fonts",
		"fontsPrefetch",
		"footerContainer",
		"formCommon",
		"galleriesCommon",
		"googleMap",
		"groupContainer",
		"headerContainer",
		"hoverBox",
		"htmlComponent",
		"image",
		"imageButton",
		"imageClientApi",
		"imageCommon",
		"imageZoom",
		"imageZoomDisplayer",
		"infoTip",
		"itunesButton",
		"layout",
		"linkBar",
		"loggingUtils",
		"loginButton",
		"matrixGallery",
		"mediaCommon",
		"mediaContainerFactory",
		"mediaControls",
		"mediaPlayer",
		"mediaZoom",
		"menuButton",
		"messageView",
		"mobileActionsMenu",
		"multilingual",
		"page",
		"paginatedGridGallery",
		"paypalButton",
		"pinItPinWidget",
		"pinterestFollow",
		"pinterestPinIt",
		"popupCloseTextButton",
		"popupContainer",
		"previewExtensionsCore",
		"qaAutomation",
		"quickActionBar",
		"radioButton",
		"radioGroup",
		"render",
		"rssButton",
		"santaPreview",
		"santaProps",
		"screenWidthContainer",
		"server",
		"singleAudioPlayer",
		"siteBackground",
		"siteButton",
		"siteUtils",
		"skinExports",
		"skins",
		"skypeCallButton",
		"slideShowGallery",
		"sliderGallery",
		"socialCommon",
		"soundCloudWidget",
		"spotifyFollow",
		"spotifyPlayer",
		"stripColumnsContainer",
		"stripContainer",
		"stripSlideShow",
		"stripSlideShowSlide",
		"subscribeForm",
		"svgCommon",
		"svgShape",
		"testUtils",
		"textArea",
		"textCommon",
		"textInput",
		"tinyMenu",
		"tpa",
		"tpaGalleries",
		"translationsUtils",
		"tweenEngine",
		"twitterFeed",
		"utils",
		"vKShareButton",
		"verticalAnchorsMenu",
		"verticalMenu",
		"video",
		"wGooglePlusOne",
		"wPhoto",
		"wRichText",
		"wTwitterFollow",
		"wTwitterTweet",
		"warmup",
		"widgets",
		"wixCode",
		"wixCodeInit",
		"wixCodeSeo",
		"wixSites",
		"wixSkinOnly",
		"wixUrlParser",
		"wixads",
		"wixappsBuilder",
		"wixappsClassics",
		"wixappsCore",
		"youTubeSubscribeButton",
		"zoomedImage"
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/santa-main-r/src/main/options/viewer.json
// module id = 24
// module chunks = 0